import type { Option, OptionValueType } from '@/types/app'
import type { FetchOnSettingsPageAttackListSenderUpdateViewQuery } from './SettingsPageAttackListSenderUpdateView.generated'
import {
  AttackListSenderSettingRuleExistence,
  AttackListSenderSettingRuleGender,
} from '@/types/schema.generated'

export const createRange = (range: Range | null | undefined): Range => {
  if (range === null || range === undefined) {
    return {
      min: null,
      max: null,
    }
  }

  return {
    min: range.min,
    max: range.max,
  }
}

export type Range = {
  min: number | null
  max: number | null
}

export const booleanOptions = [
  {
    label: '有効',
    value: true,
  },
  {
    label: '無効',
    value: false,
  },
]

export const createEntranceOptions = (
  entrances: FetchOnSettingsPageAttackListSenderUpdateViewQuery['viewer']['attackListSender']['availableCorporationEntrances']
) => [
  { value: null, text: 'プランナーを選択してください' },
  ...entrances.map(entrance => ({
    value: entrance.guid,
    text: entrance.name,
  })),
]

export const ageMinOptions: Option<OptionValueType>[] = [
  {
    value: null,
    text: '下限なし',
  },
  {
    value: 20,
    text: '20代',
  },
  {
    value: 30,
    text: '30代',
  },
  {
    value: 40,
    text: '40代',
  },
  {
    value: 50,
    text: '50代',
  },
  {
    value: 60,
    text: '60代',
  },
]

export const ageMaxOptions: Option<OptionValueType>[] = [
  {
    value: null,
    text: '上限なし',
  },
  {
    value: 29,
    text: '20代',
  },
  {
    value: 39,
    text: '30代',
  },
  {
    value: 49,
    text: '40代',
  },
  {
    value: 59,
    text: '50代',
  },
  {
    value: 69,
    text: '60代',
  },
]

export const genderOptions: Array<{
  label: string
  value: AttackListSenderSettingRuleGender
}> = [
  {
    label: '指定なし',
    value: AttackListSenderSettingRuleGender.NotSpecified,
  },
  {
    label: '男性',
    value: AttackListSenderSettingRuleGender.Male,
  },
  {
    label: '女性',
    value: AttackListSenderSettingRuleGender.Female,
  },
]

export const priceRangeMinOptions: Option<OptionValueType>[] = [
  {
    value: null,
    text: '下限なし',
  },
  {
    value: 1_000_000,
    text: '100万円台',
  },
  {
    value: 2_000_000,
    text: '200万円台',
  },
  {
    value: 3_000_000,
    text: '300万円台',
  },
  {
    value: 4_000_000,
    text: '400万円台',
  },
  {
    value: 5_000_000,
    text: '500万円台',
  },
  {
    value: 6_000_000,
    text: '600万円台',
  },
  {
    value: 7_000_000,
    text: '700万円台',
  },
  {
    value: 8_000_000,
    text: '800万円台',
  },
  {
    value: 9_000_000,
    text: '900万円台',
  },
  {
    value: 10_000_000,
    text: '1000万円台',
  },
  {
    value: 20_000_000,
    text: '2000万円台',
  },
  {
    value: 30_000_000,
    text: '3000万円台',
  },
  {
    value: 40_000_000,
    text: '4000万円台',
  },
  {
    value: 50_000_000,
    text: '5000万円台',
  },
  {
    value: 60_000_000,
    text: '6000万円台',
  },
  {
    value: 70_000_000,
    text: '7000万円台',
  },
  {
    value: 80_000_000,
    text: '8000万円台',
  },
  {
    value: 90_000_000,
    text: '9000万円台',
  },
  {
    value: 100_000_000,
    text: '1億円台',
  },
]

export const priceRangeMaxOptions: Option<OptionValueType>[] = [
  {
    value: null,
    text: '上限なし',
  },
  {
    value: 1_999_999,
    text: '100万円台',
  },
  {
    value: 2_999_999,
    text: '200万円台',
  },
  {
    value: 3_999_999,
    text: '300万円台',
  },
  {
    value: 4_999_999,
    text: '400万円台',
  },
  {
    value: 5_999_999,
    text: '500万円台',
  },
  {
    value: 6_999_999,
    text: '600万円台',
  },
  {
    value: 7_999_999,
    text: '700万円台',
  },
  {
    value: 8_999_999,
    text: '800万円台',
  },
  {
    value: 9_999_999,
    text: '900万円台',
  },
  {
    value: 19_999_999,
    text: '1000万円台',
  },
  {
    value: 29_999_999,
    text: '2000万円台',
  },
  {
    value: 39_999_999,
    text: '3000万円台',
  },
  {
    value: 49_999_999,
    text: '4000万円台',
  },
  {
    value: 59_999_999,
    text: '5000万円台',
  },
  {
    value: 69_999_999,

    text: '6000万円台',
  },
  {
    value: 79_999_999,
    text: '7000万円台',
  },
  {
    value: 89_999_999,
    text: '8000万円台',
  },
  {
    value: 99_999_999,
    text: '9000万円台',
  },
  {
    value: 199_999_999,
    text: '1億円台',
  },
]

export const existenceOptions: Array<{
  label: string
  value: AttackListSenderSettingRuleExistence
}> = [
  {
    label: '指定なし',
    value: AttackListSenderSettingRuleExistence.NotSpecified,
  },
  {
    label: 'あり',
    value: AttackListSenderSettingRuleExistence.Exist,
  },
  {
    label: 'なし',
    value: AttackListSenderSettingRuleExistence.NotExist,
  },
]

export const ageOfFirstChildMinOptions: Option<OptionValueType>[] = [
  {
    value: null,
    text: '下限なし',
  },
  {
    value: 0,
    text: '0歳',
  },
  {
    value: 1,
    text: '1歳',
  },
  {
    value: 2,
    text: '2歳',
  },
  {
    value: 3,
    text: '3歳',
  },
  {
    value: 4,
    text: '4歳',
  },
  {
    value: 5,
    text: '5歳',
  },
  {
    value: 6,
    text: '6歳',
  },
  {
    value: 7,
    text: '7歳',
  },
  {
    value: 8,
    text: '8歳',
  },
  {
    value: 9,
    text: '9歳',
  },
  {
    value: 10,
    text: '10歳',
  },
  {
    value: 11,
    text: '11歳',
  },
  {
    value: 12,
    text: '12歳',
  },
  {
    value: 13,
    text: '13歳',
  },
  {
    value: 14,
    text: '14歳',
  },
  {
    value: 15,
    text: '15歳',
  },
  {
    value: 16,
    text: '16歳',
  },
  {
    value: 17,
    text: '17歳',
  },
  {
    value: 18,
    text: '18歳',
  },
  {
    value: 19,
    text: '19歳',
  },
  {
    value: 20,
    text: '20歳',
  },
]

export const ageOfFirstChildMaxOptions: Option<OptionValueType>[] = [
  {
    value: null,
    text: '上限なし',
  },
  {
    value: 0,
    text: '0歳',
  },
  {
    value: 1,
    text: '1歳',
  },
  {
    value: 2,
    text: '2歳',
  },
  {
    value: 3,
    text: '3歳',
  },
  {
    value: 4,
    text: '4歳',
  },
  {
    value: 5,
    text: '5歳',
  },
  {
    value: 6,
    text: '6歳',
  },
  {
    value: 7,
    text: '7歳',
  },
  {
    value: 8,
    text: '8歳',
  },
  {
    value: 9,
    text: '9歳',
  },
  {
    value: 10,
    text: '10歳',
  },
  {
    value: 11,
    text: '11歳',
  },
  {
    value: 12,
    text: '12歳',
  },
  {
    value: 13,
    text: '13歳',
  },
  {
    value: 14,
    text: '14歳',
  },
  {
    value: 15,
    text: '15歳',
  },
  {
    value: 16,
    text: '16歳',
  },
  {
    value: 17,
    text: '17歳',
  },
  {
    value: 18,
    text: '18歳',
  },
  {
    value: 19,
    text: '19歳',
  },
  {
    value: 20,
    text: '20歳',
  },
]
